import axios from 'axios';

export const postPeriodicalList = (params: { site: { id: string }; pageNo: number; pageSize: number }) => {
  return axios.post('/api/internal/corporate/publications/list', params);
};

export const getPeriodicalDetail = (id: string) => {
  return axios.get(`/api/internal/corporate/publications/${id}`);
};
